import { ReportSettings, ShiftOption, ShiftsDisplayOptions } from './reportSettings.ts';

interface Props {
    reportSettings: ReportSettings;
    setReportSettings: (reportSettings: ReportSettings) => void;
    shiftsDisplayEnabled: boolean;
}

export function ReportShiftControl({
    reportSettings,
    setReportSettings,
    shiftsDisplayEnabled,
}: Props) {
    function handleShiftSelectionChange(shift: ShiftOption, isEnabled: boolean) {
        const visibleShifts = isEnabled
            ? [...reportSettings.visibleShifts, shift]
            : reportSettings.visibleShifts.filter((s) => s !== shift);

        setReportSettings({
            ...reportSettings,
            visibleShifts,
        });
    }

    return (
        <section className='report-controls__section'>
            <div className='report-controls__heading'>Shifts and days</div>
            {shiftsDisplayEnabled && (
                <div className='report-controls__segmented'>
                    {ShiftsDisplayOptions.map((value) => (
                        <button
                            key={value}
                            type='button'
                            className={reportSettings.shiftsDisplay === value ? 'selected' : undefined}
                            onClick={() => setReportSettings({ ...reportSettings, shiftsDisplay: value })}
                        >
                            {value}
                        </button>
                    ))}
                </div>
            )}
            <div className='report-controls__checks report-controls__checks--three'>
                {([
                    ['morning', 'Morning'],
                    ['evening', 'Evening'],
                    ['night', 'Night'],
                ] as const).map(([shift, label]) => (
                    <label key={shift}>
                        <input
                            type='checkbox'
                            checked={reportSettings.visibleShifts.includes(shift)}
                            onChange={(event) => handleShiftSelectionChange(shift, event.target.checked)}
                        />
                        {label}
                    </label>
                ))}
            </div>
            <div className='report-controls__checks'>
                <label>
                    <input
                        type='checkbox'
                        checked={reportSettings.workdays}
                        onChange={(event) => setReportSettings({
                            ...reportSettings,
                            workdays: event.target.checked,
                        })}
                    />
                    Workdays
                </label>
                <label>
                    <input
                        type='checkbox'
                        checked={reportSettings.weekends}
                        onChange={(event) => setReportSettings({
                            ...reportSettings,
                            weekends: event.target.checked,
                        })}
                    />
                    Weekends
                </label>
            </div>
        </section>
    );
}
